/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Predicate = {
    Field: Predicate.Field;
    Operator: Predicate.Operator;
    Value: Array<string>;
};
export namespace Predicate {
    export enum Field {
        ID = 'Id',
        NAME = 'Name',
        HOTEL_STATUS = 'HotelStatus',
        FOREIGN_PARTNER_ID = 'ForeignPartnerId',
        COUNTRY_ID = 'CountryId',
        COUNTRY_CODE = 'CountryCode',
        SETTLEMENT_ID = 'SettlementId',
        DISTRICT_ID = 'DistrictId',
        REGION_ID = 'RegionId',
        RATINGS_AVERAGE = 'RatingsAverage',
        TYPE = 'Type',
        CLASSIFICATION = 'Classification',
        DISPLAYABLE = 'Displayable',
        SCORE = 'Score',
        CHAIN_IDS = 'ChainIds',
        SERVICES = 'Services',
        ROOM_SERVICES = 'RoomServices',
        ROOM_HAS_SEPARATE_BATHROOM = 'RoomHasSeparateBathroom',
        PACKAGE_CATEGORIES = 'PackageCategories',
        PAYMENT_METHODS = 'PaymentMethods',
        PROVISION_TYPES = 'ProvisionTypes',
        ALLOWED_PETS = 'AllowedPets',
        SPOKEN_LANGUAGES = 'SpokenLanguages',
        DISTANCE = 'Distance',
        BOX_FILTER = 'BoxFilter',
        AVAILABLE = 'Available',
        TAGS = 'Tags',
        CHEAPEST_RATE = 'CheapestRate',
        MODEL = 'Model',
        FREE_CANCEL = 'FreeCancel',
        WITHOUT_PREPAYMENT = 'WithoutPrepayment',
        CAPACITY_TYPE = 'CapacityType',
    }
    export enum Operator {
        // _ = '=',
        // _ = '!=',
        // _ = '<',
        // _ = '<=',
        // _ = '>',
        // _ = '>=',
        STARTS_WITH = 'StartsWith',
        ANY = 'Any',
        NOT_ANY = 'NotAny',
        ALL = 'All',
        NOT_ALL = 'NotAll',
    }
}
